import { useTranslation } from 'react-i18next'
import { StatefulTooltip } from 'baseui/tooltip'
import { pulseTooltipOverrides } from '@/shared/components/PulseScope/styled-components'
import IconUser from '@/shared/icons/NewDesign/IconUser'
import useUnsavedChangesBadge from '../UnsavedChangesBadge/useUnsavedChangesBadge'
import PulseTabLabel from '../PulseTabLabel/PulseTabLabel'
import { PulseTabIconSlot, PulseTabLabelFrame } from '../styled-components'

interface PulseClientTabTitleProps {
  active?: boolean
}

const PulseClientTabTitle = ({ active = false }: PulseClientTabTitleProps) => {
  const { t } = useTranslation()
  const { hidden, label, onKeyDown } = useUnsavedChangesBadge()

  if (hidden) {
    return (
      <PulseTabLabel Icon={IconUser} active={active}>
        {t('common:client')}
      </PulseTabLabel>
    )
  }

  return (
    <PulseTabLabelFrame $iconAfterText>
      {t('common:client')}
      <StatefulTooltip content={label} popoverMargin={8} overrides={pulseTooltipOverrides}>
        <PulseTabIconSlot $active={active} $alert role='img' tabIndex={0} aria-label={label} onKeyDown={onKeyDown}>
          <IconUser size={16} color='currentColor' />
        </PulseTabIconSlot>
      </StatefulTooltip>
    </PulseTabLabelFrame>
  )
}

export default PulseClientTabTitle
